module.exports = __webpack_public_path__ + "img/diar-caracteristicas-imagenA.530d0ced.png";